import { AttributeTypeModel } from "@insite/client-framework/Types/ApiModels";

interface Props {
    eventName: string;
    itemId?: string;
    itemName?: string;
    transactionId?: string | null;
    currency?: string | null;
    value?: string | null;
    data: any; // add more models if needed
}

export const attributeTypeGtmReady = (attributeTypes: AttributeTypeModel[] | undefined, type: string) => {
    const newArray: string[] = []

    attributeTypes?.forEach((attributeType) => {
        if (attributeType.name === type && attributeType.attributeValues && attributeType.attributeValues?.length > 0) {
            attributeType.attributeValues?.forEach(attributeValue => {
                newArray.push(attributeValue.value)
            });
        }
    })

    if (newArray.length === 0) {
        return ""
    }

    if (newArray.length > 0) {
        const attributeTypesReadyforGtm = newArray.join("|")
        return `|${attributeTypesReadyforGtm}|`
    }
}

export const datalayerDefault = ({ eventName, itemId, itemName, data }: Props) => {
    (window as any).dataLayer = (window as any).dataLayer || [];
    (window as any).dataLayer.push({
        'event': eventName,
        'item_list_id': itemId,
        'item_list_name': itemName,
        'items': data
    });
};

export const datalayerViewProduct = ({ eventName, currency, value, data }: Props) => {
    (window as any).dataLayer = (window as any).dataLayer || [];
    (window as any).dataLayer.push({
        'event': eventName,
        'curreny': currency,
        'value': value,
        'items': data
    });
};

export const datalayerBeginCheckout = ({ eventName, currency, value, data }: Props) => {
    (window as any).dataLayer = (window as any).dataLayer || [];
    (window as any).dataLayer.push({
        'event': eventName,
        'curreny': currency,
        'value': value,
        'items': data
    });
}

export const datalayerTranaction = ({ eventName, transactionId, currency, value, data }: Props) => {
    (window as any).dataLayer = (window as any).dataLayer || [];
    (window as any).dataLayer.push({
        'event': eventName,
        'transaction_id': transactionId,
        'curreny': currency,
        'value': value,
        'items': data
    });
};

export const datalayerInterestInComingSoonProduct = ({ eventName, data }: Props) => {
    (window as any).dataLayer = (window as any).dataLayer || [];
    (window as any).dataLayer.push({
        'event': eventName,
        'items': data
    });
};

export const datalayerRequestInvoicePaymentOption = ({ eventName, data }: Props) => {
    (window as any).dataLayer = (window as any).dataLayer || [];
    (window as any).dataLayer.push({
        'event': eventName,
        'status': data
    });
};

export default { datalayerDefault, datalayerTranaction };